import { render, staticRenderFns } from "./clientsWaterMeters.vue?vue&type=template&id=2c2a35a1&"
import script from "./clientsWaterMeters.vue?vue&type=script&lang=js&"
export * from "./clientsWaterMeters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports